import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '../src/TranslationContext';
import Navbar0 from './vitrine/Components/Navbar';
import Footer from './vitrine/Components/Footer';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar0 />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <AlertTriangle className="mx-auto h-16 w-16 text-red-600 mb-4" aria-hidden="true" />
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            {t('not_found_title')}
          </h1>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            {t('not_found_message')}
          </p>
          <a
            href="/"
            className="mt-8 inline-flex items-center px-6 py-3 border border-transparent text-base font-semibold rounded-md text-white bg-pink-600 hover:bg-pink-900"
            aria-label={t('back_to_home')}
          >
            {t('back_to_home')}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;